import { SmartSendFilterContext } from '../../lib/helpers/SmartSendFilterApplier';
export const isFixSpecificIssue = (ctx: SmartSendFilterContext) => ctx?.CurrentFilter?.Name === 'Issues';
